// TODO: Need Audit
import Page from 'shared/components/page';

export default class GtmEmbed {
  static init() {
    GtmEmbed.bindLoveButton();
    GtmEmbed.bindCommentButton();
    GtmEmbed.bindShareButton();
    GtmEmbed.bindShareFacebook();
    GtmEmbed.bindShareTwitter();
    GtmEmbed.bindTitle();
    GtmEmbed.bindFollowing();
    GtmEmbed.bindUserProfile();
  }

  static bindLoveButton() {
    $('.widget__actions__button-like').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'embed-watch now',
        feature_location: 'love',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindCommentButton() {
    $('.widget__actions__button-comment').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'embed-watch now',
        feature_location: 'comment',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindShareFacebook() {
    $('.widget__modal__share-facebook').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'share',
        feature_location: 'embed/facebook',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindShareTwitter() {
    $('.widget__modal__share-twitter').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'share',
        feature_location: 'embed/twitter',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindShareButton() {
    $('.widget__actions__button-share').on('click', function() {
      window.dataLayer.push({
        event: 'impression',
        feature_name: 'share',
        feature_location: 'embed',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindTitle() {
    $('.widget__title-link').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'embed-watch now',
        feature_location: 'title',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindFollowing() {
    $('.button-follow').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'embed-watch now',
        feature_location: 'following',
        feature_type: 'vod.' + Page.id()
      });
    });
  }

  static bindUserProfile() {
    $('.widget__user-avatar, .widget__user-link').on('click', function() {
      window.dataLayer.push({
        event: 'click',
        feature_name: 'embed-watch now',
        feature_location: 'user profile',
        feature_type: 'vod.' + Page.id()
      });
    });
  }
}
